// extracted by mini-css-extract-plugin
module.exports = {"bio_section":"__bio_section__ZiHUA","designation":"__designation__JQT02"};